import React from "react";
import { Heart, Users, Check } from "lucide-react";
import { IMAGES } from "../../data/content";
import { useLang } from "../../i18n/LanguageContext";

const recipeMeta = [
  { img: IMAGES.swiss, votes: 3, win: true },
  { img: IMAGES.pasta, votes: 1 },
  { img: IMAGES.noodles, votes: 1 }
];

export const PhoneMockup = () => {
  const { t } = useLang();
  const recipes = t.phone.recipes.map((r, i) => ({ ...r, ...recipeMeta[i] }));

  return (
    <div className="relative mx-auto w-[280px] sm:w-[320px]" data-testid="app-phone-mockup">
      <div className="rounded-[2.75rem] border-[10px] border-petrol bg-petrol p-2 shadow-[0_30px_80px_rgba(15,37,55,0.35)]">
        <div className="overflow-hidden rounded-[2rem] bg-cream">
          <div className="flex items-center justify-between px-6 pt-4 text-[11px] font-semibold text-petrol/70">
            <span>9:41</span>
            <span className="h-2 w-14 rounded-full bg-petrol/15" />
            <span>100%</span>
          </div>

          <div className="px-5 pb-3 pt-3">
            <p className="text-xs font-semibold uppercase tracking-widest text-terracotta">
              {t.phone.household}
            </p>
            <h3 className="font-heading text-xl font-extrabold text-petrol">
              {t.phone.title}
            </h3>
            <div className="mt-2 flex items-center gap-1.5 text-[11px] text-petrol-soft">
              <Users className="h-3.5 w-3.5" strokeWidth={2} />
              <span>{t.phone.voting}</span>
              <span className="ml-1 flex gap-1">
                {["bg-terracotta", "bg-petrol", "bg-emerald-500", "bg-amber-400"].map((c, i) => (
                  <span key={i} className={`h-2 w-2 rounded-full ${c}`} />
                ))}
              </span>
            </div>
          </div>

          <div className="space-y-3 px-5 pb-6">
            {recipes.map((r) => (
              <div
                key={r.name}
                className={`flex items-center gap-3 rounded-2xl bg-white p-2.5 shadow-sm ${
                  r.win ? "ring-2 ring-terracotta" : "ring-1 ring-petrol/5"
                }`}
              >
                <img
                  src={r.img}
                  alt={r.name}
                  className="h-14 w-14 shrink-0 rounded-xl object-cover"
                  loading="lazy"
                />
                <div className="min-w-0 flex-1">
                  <p className="truncate font-heading text-sm font-bold text-petrol">
                    {r.name}
                  </p>
                  <p className="text-[11px] text-petrol-soft">{r.meta}</p>
                </div>
                <div className="flex flex-col items-center">
                  {r.win ? (
                    <span className="flex h-7 w-7 items-center justify-center rounded-full bg-terracotta text-white">
                      <Check className="h-4 w-4" strokeWidth={3} />
                    </span>
                  ) : (
                    <Heart className="h-5 w-5 text-petrol/25" strokeWidth={2} />
                  )}
                  <span className="mt-1 text-[10px] font-bold text-petrol-soft">
                    {r.votes}
                  </span>
                </div>
              </div>
            ))}
            <button className="mt-1 w-full rounded-2xl bg-terracotta py-3 font-heading text-sm font-bold text-white">
              {t.phone.cook}
            </button>
          </div>
        </div>
      </div>

      <div className="absolute -bottom-5 -left-4 hidden rounded-2xl bg-white px-4 py-3 shadow-[0_12px_30px_rgba(15,37,55,0.15)] lg:block">
        <p className="font-heading text-2xl font-extrabold text-terracotta">3</p>
        <p className="text-[10px] font-semibold uppercase tracking-wider text-petrol-soft">
          {t.phone.ideas}
        </p>
      </div>
    </div>
  );
};
